var render, staticRenderFns
import script from "./BpClickable.vue?vue&type=script&lang=js&"
export * from "./BpClickable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0e87db2d')) {
      api.createRecord('0e87db2d', component.options)
    } else {
      api.reload('0e87db2d', component.options)
    }
    
  }
}
component.options.__file = "resources/styles/utilities/clickable/BpClickable.vue"
export default component.exports